export const TRUE_FIT_ENABLED_DIVISIONS = [11]

export const TRUE_FIT_ENABLED_DEPARTMENTS = [16, 10, 11, 97, 85, 13, 12, 26, 6, 84, 9]
